import { render } from "./FrontGates.vue?vue&type=template&id=794898bb"
import script from "./FrontGates.vue?vue&type=script&lang=js"
export * from "./FrontGates.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__